import { useState } from "react";

import { Button, Card, Tooltip } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import { selectIsOwner, selectMyUserId } from "redux/slices/session";
import DeactivateUserDialog from "routes/users/pattern/components/DeactivateUserDialog";
import { selectUserById } from "redux/slices/client";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { Navigate } from "react-router";

const UserAdvanced = () => {
  const isOwner = useAppSelector(selectIsOwner);
  const { userId } = useParamNumbers(["userId"]);
  const user = useAppSelector((state) => selectUserById(state, userId));

  if (user === undefined) {
    return <Navigate to="/users" replace />;
  }

  const myId = useAppSelector(selectMyUserId);
  const [promptDeactivateOpen, setPromptDeactivateOpen] = useState<boolean>(false);
  const disabledReason: string | undefined = !isOwner
    ? "Insufficient Permissions"
    : myId === userId
      ? "You cannot deactivate yourself"
      : undefined;

  const isDisabled = disabledReason !== undefined;

  return (
    <>
      <Card className="p-4 flex justify-between items-center">
        {!user.deactivated ? (
          <div className="flex flex-col">
            <p className="text-lg font-bold">Deactivate User</p>
            <p className="text-sm">You&apos;ll be prompted to decide how to reassign the users cases</p>
          </div>
        ) : (
          <div className="flex flex-col">
            <p className="text-lg font-bold">Reactivate User</p>
            <p className="text-sm">User will have access to the lenses selected in the &apos;Lens Access&apos; tab.</p>
          </div>
        )}
        <div>
          <Tooltip title={disabledReason}>
            <span>
              <Button disabled={isDisabled} variant="contained" onClick={() => setPromptDeactivateOpen(true)}>
                {!user.deactivated ? "Deactivate" : "Reactivate"}
              </Button>
            </span>
          </Tooltip>
        </div>
      </Card>
      <DeactivateUserDialog open={promptDeactivateOpen} setOpen={setPromptDeactivateOpen} user={user} />
    </>
  );
};

export default UserAdvanced;
